<template>
  <ModalCard>
    <template #body>
      <section
        class="is-flex-centered"
        :data-e2e="AdminCypressAttribute.views.GIVE_FEEDBACK_MODAL_BODY"
      ></section>
    </template>
  </ModalCard>
</template>

<script>
import ModalCard from '@/modules/core/ui/components/ModalCard.vue';
import { AdminCypressAttribute } from '@/modules/admin/constants/AdminCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'GiveFeedbackModal',
  components: { ModalCard },
  static: {
    AdminCypressAttribute
  },
  mounted() {
    this.$el?.closest?.('.modal-card')?.classList?.add('has-background-transparent');
  }
};
</script>
